import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import FormFields from '../form-fields';

import MinusCircledPath from './../../assets/minusCircled.svg?react';

export const LeftBottomArrow = styled.div`
    border-left: 16px solid transparent;
    border-right: 16px solid var(--color-white);
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    left: -31px;
    position: absolute;
    bottom: 52px;
`;

export const LeftTopArrow = styled.div`
    border-left: 16px solid transparent;
    border-right: 16px solid var(--color-white);
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    left: -31px;
    position: absolute;
    top: 53px;
`;

export const AttachmentContainer = styled.div`
    margin: 0 0 0 16px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    margin: 16px;
`;

const IconButton = styled.button`
    border: none;
    background: transparent;

    width: 18px;
    height: 18px;
    padding: 0;

    & > svg {
        fill: ${(props) => props.theme.colors['myzanichelli-blue-main']};
    }

    & > svg:hover {
        fill: ${(props) => props.theme.colors['myzanichelli-blue-dark']};
    }

    &:focus {
        outline: none;
    }

    &:hover {
        cursor: pointer;
    }
`;

const Container = styled.div`
    color: var(--gray800);
    display: flex;
    flex-direction: column;
    position: relative;
    width: 334px;
`;

const Content = styled.div`
    background: var(--color-white);
    border-radius: 4px;
    border: 1px solid var(--gray200);
    box-shadow: var(--shadow-12);
    padding-bottom: 16px;
    width: 100%;
`;

const Title = styled.span`
    font-size: 20px;
`;

const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--gray50);
    box-sizing: border-box;
    height: 52px;
    padding: 16px 12px;
`;

const ReportPopover = ({ hideReport, snackbarStatus, httpStatus, clearForm, isCorrectionPage }) => {
    const handleClick = () => {
        hideReport();
        if (httpStatus.loaded) {
            clearForm();
        }
    };
    return (
        <Container>
            <Content>
                <TitleContainer>
                    <Title>{'Problemi o suggerimenti?'}</Title>
                    <IconButton onClick={handleClick}>
                        <MinusCircledPath />
                    </IconButton>
                </TitleContainer>

                <FormFields snackbarStatus={snackbarStatus} />
            </Content>
            {isCorrectionPage ? <LeftTopArrow /> : <LeftBottomArrow />}
        </Container>
    );
};

ReportPopover.propTypes = {
    hideReport: PropTypes.func,
    snackbarStatus: PropTypes.string,
    httpStatus: PropTypes.object,
    isCorrectionPage: PropTypes.bool,
    clearForm: PropTypes.func,
};

export default ReportPopover;
